import { render, staticRenderFns } from "./AppPhoto.vue?vue&type=template&id=05bfec86&"
import script from "./AppPhoto.vue?vue&type=script&lang=js&"
export * from "./AppPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports